module.exports = __webpack_public_path__ + "img/policy-management-zero-design.aca918be.png";